import axios from "axios";

export default axios.create({
  baseURL: "https://assets.remsys.com.ng/Documents",
});
